import AssignPropertiesToPortfolioModal from "./AssignPropertiesToPortfolioModalContainer";

export default AssignPropertiesToPortfolioModal;
